import * as React from "react";
import { Select } from "atoms";
import { linkTypes, marketplaceTypes } from "../data/linkTypes";

type SelectReviewableLinkTypeProps = {
  marketplacesOnly?: boolean;
};

const SelectReviewableLinkType = React.forwardRef<
  HTMLSelectElement,
  SelectReviewableLinkTypeProps
>(({ marketplacesOnly = false, ...props }, ref) => (
  <Select {...props} ref={ref}>
    {(marketplacesOnly ? marketplaceTypes : linkTypes).map((opt) => (
      <option key={opt} value={opt}>
        {opt === "async.art"
          ? "Async Art"
          : `${opt[0].toUpperCase()}${opt.slice(1)}`}
      </option>
    ))}
  </Select>
));

export { SelectReviewableLinkType };
